/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";

export const UsersAndPermissionsSchema = yup.object().shape({
  email: yup.string().email().required(),
});
